import { defineMessages } from 'react-intl';

const messages = defineMessages({
  account: {
    id: 'routes.account',
    defaultMessage: 'Account',
  },
  add: {
    id: 'routes.add',
    defaultMessage: 'Add',
  },
  admin: {
    id: 'routes.admin',
    defaultMessage: 'Admin',
  },
  analytics: {
    id: 'routes.analytics',
    defaultMessage: 'Analytics',
  },
  backToHome: {
    id: 'routes.backToHome',
    defaultMessage: 'Back to Home',
  },
  bookingEvents: {
    id: 'routes.bookingEvents',
    defaultMessage: 'Book a session',
  },
  bookingEventTemplates: {
    id: 'routes.bookingEventTemplates',
    defaultMessage: 'Booking templates',
  },
  bookingStats: {
    id: 'routes.bookingStats',
    defaultMessage: 'Session statistics',
  },
  bookingVip: {
    id: 'routes.bookingVip',
    defaultMessage: 'Reserved seat',
  },
  branding: {
    id: 'routes.branding',
    defaultMessage: 'Branding',
  },
  categories: {
    id: 'routes.categories',
    defaultMessage: 'Categories',
  },
  clients: {
    id: 'routes.clients',
    defaultMessage: 'Clients',
  },
  configurables: {
    id: 'routes.configurables',
    defaultMessage: 'Configurables',
  },
  corpoStats: {
    id: 'routes.corpoStats',
    defaultMessage: 'Corpo Stats',
  },
  dashboard: {
    id: 'routes.dashboard',
    defaultMessage: 'Dashboard',
  },
  desk: {
    id: 'routes.desk',
    defaultMessage: 'Reception',
  },
  edit: {
    id: 'routes.edit',
    defaultMessage: 'Edit',
  },
  education: {
    id: 'routes.education',
    defaultMessage: 'Education',
  },
  exercises: {
    id: 'routes.exercises',
    defaultMessage: 'Exercises',
  },
  finance: {
    id: 'routes.finance',
    defaultMessage: 'Finance',
  },
  home: {
    id: 'routes.home',
    defaultMessage: 'Home',
  },
  library: {
    id: 'routes.library',
    defaultMessage: 'Library',
  },
  list: {
    id: 'routes.list',
    defaultMessage: 'List',
  },
  management: {
    id: 'routes.management',
    defaultMessage: 'Management',
  },
  me: {
    id: 'routes.me',
    defaultMessage: 'Account',
  },
  members: {
    id: 'routes.members',
    defaultMessage: 'Organization Members',
  },
  memberships: {
    id: 'routes.memberships',
    defaultMessage: 'Memberships',
  },
  myOrganization: {
    id: 'routes.myOrganization',
    defaultMessage: 'My Organization',
  },
  notificationCenter: {
    id: 'routes.notificationCenter',
    defaultMessage: 'Notification Center',
  },
  nutrition: {
    id: 'routes.nutrition',
    defaultMessage: 'Nutrition',
  },
  organization: {
    id: 'routes.organization',
    defaultMessage: 'Organization',
  },
  organizationMembers: {
    id: 'routes.organizationMembers',
    defaultMessage: 'Organization Members',
  },
  organizationProfile: {
    id: 'routes.organizationProfile',
    defaultMessage: 'Organization Profile',
  },
  organizationAdd: {
    id: 'routes.organizationAdd',
    defaultMessage: 'Add organization',
  },
  organizations: {
    id: 'routes.organizations',
    defaultMessage: 'Organizations',
  },
  overview: {
    id: 'routes.overview',
    defaultMessage: 'Overview',
  },
  payouts: {
    id: 'routes.payouts',
    defaultMessage: 'Payouts',
  },
  premium: {
    id: 'routes.premium',
    defaultMessage: 'Premium',
  },
  privacyPolicies: {
    id: 'routes.privacyPolicies',
    defaultMessage: 'Privacy Policies',
  },
  programs: {
    id: 'routes.programs',
    defaultMessage: 'Programs',
  },
  public: {
    id: 'routes.public',
    defaultMessage: 'Public',
  },
  questionnaires: {
    id: 'routes.questionnaires',
    defaultMessage: 'Questionnaires',
  },
  marketplaceAccess: {
    id: 'routes.marketplaceAccess',
    defaultMessage: 'Marketplace access',
  },
  publicPages: {
    id: 'routes.publicPages',
    defaultMessage: 'Public Pages',
  },
  roles: {
    id: 'routes.roles',
    defaultMessage: 'Roles',
  },
  rolesAndPermissions: {
    id: 'routes.rolesAndPermissions',
    defaultMessage: 'Roles & Permissions',
  },
  schedule: {
    id: 'routes.schedule',
    defaultMessage: 'Schedule',
  },
  security: {
    id: 'routes.security',
    defaultMessage: 'Security',
  },
  staff: {
    id: 'routes.staff',
    defaultMessage: 'Reception',
  },
  stats: {
    id: 'routes.stats',
    defaultMessage: 'Statistics',
  },
  tags: {
    id: 'routes.tags',
    defaultMessage: 'Tags',
  },
  tenants: {
    id: 'routes.tenants',
    defaultMessage: 'Tenants',
  },
  trainers: {
    id: 'routes.trainers',
    defaultMessage: 'Trainers',
  },
  users: {
    id: 'routes.users',
    defaultMessage: 'Users',
  },
  wallet: {
    id: 'routes.wallet',
    defaultMessage: 'Wallet',
  },
  workouts: {
    id: 'routes.workouts',
    defaultMessage: 'Workouts',
  },
});

export type RoutesMessagesDescriptor = keyof typeof messages;
export default messages;
